import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import { 
  FormControl, Grid, InputLabel, Select, OutlinedInput, 
  MenuItem, FormLabel, FormGroup, FormControlLabel, 
  Checkbox 
} from '@material-ui/core';
import * as strings from "../../helpers/strings";

import * as portfolioFaultReducer from '../reducer';
import * as portfolioFaultActionMgr from '../action-mgr';
import { months } from '../../helpers/constants';

import { getUserId } from '../../helpers/common';

const styles = {
  formControlWrapper: { marginBottom: 15 },
  formControlWrapperSelectMenu: {
    '& > div > div': {
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    },
  },
  formControlWrapperCheckbox: {
    width: '100%',
    marginBottom: 10,
    paddingLeft: '10px',
    border: '1px solid #0000003d',
    borderRadius: '5px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    maxHeight: '418px', // Limit height 
    overflowY: 'auto', // Enable vertical scrolling
    
  },
  scrollContainer: {
    maxHeight: 'calc(100vh - 410px)',           // Limit height to trigger scroll
    overflowY: 'auto',            // Enable vertical scrolling
    scrollBehavior: 'smooth',     // Smooth scrolling effect
    padding: '5px 0px', // Add padding to the scrollbar area

    /* Custom Scrollbar for WebKit Browsers */
    '&::-webkit-scrollbar': {
      width: '6px',               // Narrow scrollbar width
    },
    '&::-webkit-scrollbar-track': {
      background: '#f0f0f0',      // Light gray background
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',    // Darker scroll thumb
      borderRadius: '4px',
      border: '2px solid #f0f0f0'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',         // Darker on hover
    },
  },
  stationScrollWrapper: {
    maxHeight: '340px',            // Adjust height as needed
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    // Slim custom scrollbar
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f0f0f0',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
      border: '2px solid #f0f0f0',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },  
  rangeLabel: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  dateRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: '10px', // Spacing between fields
  },
  CheckboxFormLabelCountry: { textAlign: 'left', padding: '0px 2px', fontSize: '13px', width: '55px' },
  CheckboxFormLabelCity: { textAlign: 'left', padding: '0px 2px', fontSize: '13px', width: '30px' },
  CheckboxFormLabelProject: { textAlign: 'left', padding: '0px 2px', fontSize: '13px', width: '50px' },
}

class PortfolioFaultForm extends Component {
  hasAutoSelectedCountries = false;
  hasAutoSelectedStations = false;
  hasInitialPortfolioFaultFetched = false;
  hasInitialPortfolioFaultLogFetched = false; 

  lastFetchedCompany = null; 

  constructor(props) {
    super(props);

    const { portfolioFaultDetails } = props;
    const stationNames = (portfolioFaultDetails.stationDetails || []).map(station => station.name);

    this.state = {
      selectedFaultCountries: portfolioFaultDetails.countryList || [],
      selectAllFaultCountries: (portfolioFaultDetails.countryList || []).length > 0,

      selectedFaultCities: portfolioFaultDetails.cityList || [],
      selectAllFaultCities: (portfolioFaultDetails.cityList || []).length > 0,

      selectedFaultProjects: portfolioFaultDetails.projectList || [],
      selectAllFaultProjects: (portfolioFaultDetails.projectList || []).length > 0,

      selectedFaultStations: stationNames,
      selectAllFaultStations: stationNames.length > 0,

      selectedPortfolioFaultLevel: 'country',
      selectedFaultDisplayMode: portfolioFaultDetails.displayMode || 'year',
    };
  }
  
  getDaysInMonth = (year, month) => {
    if (!year || !month) return [];
  
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => i + 1);
  };
  
  getAvailableMonths = (year) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // JS months are 0-indexed
  
    return months.map(({ value, name }) => {
      let disabled = false;
  
      if (parseInt(year, 10) === currentYear) {
        // Disable months in the future
        disabled = value > currentMonth;
      } else if (parseInt(year, 10) > currentYear) {
        // Disable all months for future years
        disabled = true;
      }
  
      return { value, name, disabled };
    });
  };

  componentDidMount() {
    const { 
      callPortfolioFaultTotalize,
      callPortfolioFaultLevels,
      portfolioFaultTotalize,
      selectedPortfolioFaultCompany,
      setSelectedPortfolioFaultCompany,
    } = this.props;

    const userId = getUserId();
    const companyName = selectedPortfolioFaultCompany || portfolioFaultTotalize.companyName;

    if (companyName && !selectedPortfolioFaultCompany) {
      setSelectedPortfolioFaultCompany(companyName);
    }
    // Latest year (string for DTO)
    const currentYearStr = String(new Date().getFullYear());

    const totalizeFaultRequest = {
      userId,
      ...(companyName && { company: companyName }),
      year: currentYearStr
    };
    callPortfolioFaultTotalize(totalizeFaultRequest);
    callPortfolioFaultLevels(); 

    // 💡 Set current year as default selectedPortfolioFaultYear
    const currentYear = new Date().getFullYear();
    this.props.setSelectedPortfolioFaultYear(currentYear);
    this.props.setSelectedPortfolioFaultMonth(new Date().getMonth() + 1); // Months are 0-indexed
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      callPortfolioFaultTotalize,
      callPortfolioFaultDetails,
      callPortfolioFault,
      callPortfolioFaultLog,
      portfolioFaultDetails,
      portfolioFaultLevels,
      selectedPortfolioFaultCompany,
      selectedPortfolioFaultCountry,
      selectedPortfolioFaultCity,
      selectedPortfolioFaultProject,
      selectedPortfolioFaultStations,
      selectedPortfolioFaultDisplayMode,
      selectedPortfolioFaultYear,
      selectedPortfolioFaultMonth,
      selectedPortfolioFaultDay,

    } = this.props;

    const {
      selectedFaultCountries,
      selectedFaultStations,
      selectedPortfolioFaultLevel
    } = this.state;

    const userId = getUserId();
    const stationsChanged = JSON.stringify(selectedFaultStations) !== JSON.stringify(prevState.selectedFaultStations);
    const countriesSelected = selectedFaultCountries.length > 0;
    const stationList = selectedFaultStations || [];

    // Default portfolio level (first load)
    if (
      !this.state.selectedPortfolioFaultLevel &&
      portfolioFaultLevels.length > 0 &&
      prevProps.portfolioFaultLevels !== portfolioFaultLevels
    ) {
      const defaultLevel = portfolioFaultLevels.find(level => level.portfolioSelection.toLowerCase() === 'country');
      if (defaultLevel) {
        this.setState({ selectedPortfolioFaultLevel: defaultLevel.portfolioSelection.toLowerCase() });
      }
    }
    const companyChanged = prevProps.selectedPortfolioFaultCompany !== selectedPortfolioFaultCompany;

    const countryListChanged = JSON.stringify(prevProps.portfolioFaultDetails.countryList) !== JSON.stringify(portfolioFaultDetails.countryList);

    if (
      (!this.hasAutoSelectedCountries || companyChanged || countryListChanged) &&
      selectedPortfolioFaultLevel === 'country' &&
      portfolioFaultDetails.countryList.length > 0
    ) {
      const countries = portfolioFaultDetails.countryList;
      const allStations = portfolioFaultDetails.stationDetails || [];
    
      const filteredStations = allStations
        .filter(station => countries.includes(station.country))
        .map(station => station.name);
    
      this.setState({
        selectedFaultCountries: countries,
        selectAllFaultCountries: true,
        selectedFaultStations: filteredStations,
        selectAllFaultStations: filteredStations.length === allStations.length
      }, () => {
        this.props.setSelectedPortfolioFaultCountry(countries);
        this.props.setSelectedPortfolioFaultStations(filteredStations);
        this.hasAutoSelectedCountries = true;
        this.hasAutoSelectedStations = true;
      });
    }    

    // Auto-select stations
    if (
      !this.hasAutoSelectedStations &&
      portfolioFaultDetails.stationDetails?.length > 0 &&
      selectedFaultStations.length === 0 
    ) {
      const stations = portfolioFaultDetails.stationDetails.map(s => s.name);
      this.setState({ selectedFaultStations: stations, selectAllFaultStations: true });
      this.props.setSelectedPortfolioFaultStations(stations);
      this.hasAutoSelectedStations = true;
    }

    // Refetch portfolio fault details when filters change
    const filtersChanged =
      prevProps.selectedPortfolioFaultCompany !== selectedPortfolioFaultCompany ||
      prevProps.selectedPortfolioFaultCountry !== selectedPortfolioFaultCountry ||
      prevProps.selectedPortfolioFaultCity !== selectedPortfolioFaultCity ||
      prevProps.selectedPortfolioFaultProject !== selectedPortfolioFaultProject ||
      prevState.selectedPortfolioFaultLevel !== selectedPortfolioFaultLevel ||
      prevProps.selectedPortfolioFaultDisplayMode !== selectedPortfolioFaultDisplayMode ||
      prevProps.portfolioFaultDetails !== portfolioFaultDetails;

    if (filtersChanged && selectedPortfolioFaultCompany && selectedPortfolioFaultCompany !== this.lastFetchedCompany) {
      const formatArray = (val) => Array.isArray(val) ? (val.length ? val : ['all']) : val ? [val] : ['all'];
      callPortfolioFaultDetails({
        userId,
        company: formatArray(selectedPortfolioFaultCompany),
        country: formatArray(selectedPortfolioFaultCountry),
        city: formatArray(selectedPortfolioFaultCity),
        project: formatArray(selectedPortfolioFaultProject),
      });
      this.lastFetchedCompany = selectedPortfolioFaultCompany;
    }

    // Generate query date(s)
    const pad = (v) => v.toString().padStart(2, '0');
    let queryDate = '';

    if (selectedPortfolioFaultDisplayMode === 'year' && selectedPortfolioFaultYear) {
      queryDate = `${selectedPortfolioFaultYear}-01-01`;
    } else if (selectedPortfolioFaultDisplayMode === 'month' && selectedPortfolioFaultYear && selectedPortfolioFaultMonth) {
      queryDate = `${selectedPortfolioFaultYear}-${pad(selectedPortfolioFaultMonth)}-01`;
    }

    // Fetch fault data only when valid
    const displayModeChanged = prevProps.selectedPortfolioFaultDisplayMode !== selectedPortfolioFaultDisplayMode;
    const dateChanged = (
      prevProps.selectedPortfolioFaultYear !== selectedPortfolioFaultYear ||
      prevProps.selectedPortfolioFaultMonth !== selectedPortfolioFaultMonth
    );

    const isMonthReady =
    selectedPortfolioFaultDisplayMode === 'month' &&
    selectedPortfolioFaultYear &&
    !!selectedPortfolioFaultMonth; // Only true when month is selected

    const isYearReady = selectedPortfolioFaultDisplayMode === 'year' && selectedPortfolioFaultYear;
    const isDateReady = (selectedPortfolioFaultDisplayMode === 'month' && isMonthReady) || (selectedPortfolioFaultDisplayMode === 'year' && isYearReady);

    const shouldFetch =
      countriesSelected &&
      stationList.length > 0 &&
      queryDate &&
      isDateReady && 
      (
        !this.hasInitialPortfolioFaultFetched ||
        !this.hasInitialPortfolioFaultLogFetched ||
        stationsChanged ||
        displayModeChanged ||
        dateChanged
      );

    if (
      shouldFetch &&
      Array.isArray(portfolioFaultDetails.stationDetails) &&
      portfolioFaultDetails.stationDetails.length > 0
    ) {
      const requestBody = {
        stations: stationList,
        displayMode: selectedPortfolioFaultDisplayMode,
        queryDate
      };

      callPortfolioFault(requestBody);
      callPortfolioFaultLog(requestBody);
      this.hasInitialPortfolioFaultFetched = true;
      this.hasInitialPortfolioFaultLogFetched = true;
    }
   
    // Totalize: year-only (year display mode), or year + month (month display mode with month selected)
    const yearChangedByUser =
      prevProps.selectedPortfolioFaultYear &&
      prevProps.selectedPortfolioFaultYear !== selectedPortfolioFaultYear &&
      !!selectedPortfolioFaultYear;

    const monthChangedByUser =
      selectedPortfolioFaultDisplayMode === 'month' &&
      prevProps.selectedPortfolioFaultMonth !== selectedPortfolioFaultMonth &&
      selectedPortfolioFaultMonth !== '' &&
      selectedPortfolioFaultMonth != null;

    const switchedToYearFromMonth =
      displayModeChanged &&
      selectedPortfolioFaultDisplayMode === 'year' &&
      prevProps.selectedPortfolioFaultDisplayMode === 'month';

    const switchedToMonthFromYear =
      displayModeChanged &&
      selectedPortfolioFaultDisplayMode === 'month' &&
      prevProps.selectedPortfolioFaultDisplayMode === 'year';

    const shouldTotalizeYearView =
      !!selectedPortfolioFaultCompany &&
      selectedPortfolioFaultDisplayMode === 'year' &&
      !!selectedPortfolioFaultYear &&
      (yearChangedByUser || switchedToYearFromMonth);

    const shouldTotalizeMonthView =
      !!selectedPortfolioFaultCompany &&
      selectedPortfolioFaultDisplayMode === 'month' &&
      !!selectedPortfolioFaultYear &&
      !!selectedPortfolioFaultMonth &&
      (yearChangedByUser || monthChangedByUser || switchedToMonthFromYear);

    if (shouldTotalizeYearView || shouldTotalizeMonthView) {
      const totalizePayload = {
        userId,
        company: selectedPortfolioFaultCompany,
        year: String(selectedPortfolioFaultYear),
      };
      if (selectedPortfolioFaultDisplayMode === 'month' && selectedPortfolioFaultMonth) {
        totalizePayload.month = String(selectedPortfolioFaultMonth);
      }
      callPortfolioFaultTotalize(totalizePayload);
    }
  }

  handleCompanyChange = async (event) => {
    const selectedFaultCompany = event.target.value;
    if (selectedFaultCompany === this.props.selectedPortfolioFaultCompany) {
      return; // Don't reset or re-fetch anything if same company is selected
    }
    const { 
      callPortfolioFaultTotalize, 
      callPortfolioFaultDetails,
      setSelectedPortfolioFaultCompany,
      setSelectedPortfolioFaultCountry,
      setSelectedPortfolioFaultCity,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations,
      setSelectedPortfolioFaultDisplayMode,
      setSelectedPortfolioFaultYear,
      setSelectedPortfolioFaultMonth,
      setSelectedPortfolioFaultDay,
      setSelectedPortfolioFaultLevel,
      resetPortfolioFaultData,
      resetPortfolioFaultLog,
    } = this.props;
  
    const userId = getUserId();
  
    // Clear all Redux and local state
    resetPortfolioFaultData();
    resetPortfolioFaultLog();
  
    setSelectedPortfolioFaultCompany(selectedFaultCompany);
    setSelectedPortfolioFaultCountry([]);
    setSelectedPortfolioFaultCity([]);
    setSelectedPortfolioFaultProject([]);
    setSelectedPortfolioFaultStations([]);
    setSelectedPortfolioFaultDisplayMode('year');
    setSelectedPortfolioFaultYear('');
    setSelectedPortfolioFaultMonth('');
    setSelectedPortfolioFaultDay('');

    this.setState({ selectedPortfolioFaultLevel: 'country' });
    setSelectedPortfolioFaultLevel('country');
  
  
    this.setState({
      selectedFaultCountries: [],
      selectAllFaultCountries: false,
      selectedFaultCities: [],
      selectAllFaultCities: false,
      selectedFaultProjects: [],
      selectAllFaultProjects: false,
      selectedFaultStations: [],
      selectAllFaultStations: false,
    });
  
    this.hasAutoSelectedCountries = false;
    this.hasAutoSelectedStations = false;
  
    const portfolioFaultDetailsRequest = {
      userId,
      company: [selectedFaultCompany],
      country: ['all'],
      city: ['all'],
      project: ['all'],
    };
    const updatedPortfolioFaultDetails = await callPortfolioFaultDetails(portfolioFaultDetailsRequest);
  
    const updatedCountries = updatedPortfolioFaultDetails?.countryList || [];
    const updatedCities = updatedPortfolioFaultDetails?.cityList || [];
    const updatedProjects = updatedPortfolioFaultDetails?.projectList || [];
    const updatedStations = (updatedPortfolioFaultDetails?.stationDetails || []).map(s => s.name);
  
    const yearList = updatedPortfolioFaultDetails?.yearList || [];
    const latestYear = yearList.length > 0 ? Math.max(...yearList.map(Number)) : new Date().getFullYear();
  
    // Auto-select all available filters
    this.setState({
      selectedFaultCountries: updatedCountries,
      selectAllFaultCountries: updatedCountries.length > 0,
      selectedFaultCities: updatedCities,
      selectAllFaultCities: updatedCities.length > 0,
      selectedFaultProjects: updatedProjects,
      selectAllFaultProjects: updatedProjects.length > 0,
      selectedFaultStations: updatedStations,
      selectAllFaultStations: updatedStations.length > 0
    });
  
    setSelectedPortfolioFaultCountry(updatedCountries);
    setSelectedPortfolioFaultCity(updatedCities);
    setSelectedPortfolioFaultProject(updatedProjects);
    setSelectedPortfolioFaultStations(updatedStations);
    setSelectedPortfolioFaultYear(latestYear);

    // Fetch new totalize and fault details for selected company
    await callPortfolioFaultTotalize({ userId, company: selectedFaultCompany });
  };
  
  handlePortfolioFaultLevelChange = (event) => {
    const selectedFaultLevel = event.target.value;

    const {
      portfolioFaultDetails,
      setSelectedPortfolioFaultCountry,
      setSelectedPortfolioFaultCity,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultLevel
    } = this.props;

    this.setState({
      selectedPortfolioFaultLevel: selectedFaultLevel,
      selectedFaultCountries: [],
      selectAllFaultCountries: false,
      selectedFaultCities: [],
      selectAllFaultCities: false,
      selectedFaultProjects: [],
      selectAllFaultProjects: false,
    });

    setSelectedPortfolioFaultLevel(selectedFaultLevel);
    if (selectedFaultLevel.toLowerCase() === 'country') {
      const countries = portfolioFaultDetails.countryList || [];
      this.setState({
        selectedFaultCountries: countries,
        selectAllFaultCountries: countries.length > 0,
      });
      setSelectedPortfolioFaultCountry(countries);

    } else if (selectedFaultLevel.toLowerCase() === 'city') {
      const countries = portfolioFaultDetails.countryList || [];
      const cities = portfolioFaultDetails.cityList || [];
      this.setState({
        selectedFaultCountries: countries,
        selectAllFaultCountries: countries.length > 0,
        selectedFaultCities: cities,
        selectAllFaultCities: cities.length > 0,
      });
      setSelectedPortfolioFaultCountry(countries);
      setSelectedPortfolioFaultCity(cities);

    } else if (selectedFaultLevel.toLowerCase() === 'project') {
      const countries = portfolioFaultDetails.countryList || [];
      const cities = portfolioFaultDetails.cityList || [];
      const projects = portfolioFaultDetails.projectList || [];

      this.setState({
        selectedFaultCountries: countries,
        selectAllFaultCountries: countries.length > 0,
        selectedFaultCities: cities,
        selectAllFaultCities: cities.length > 0,
        selectedFaultProjects: projects,
        selectAllFaultProjects: projects.length > 0,
      });
      setSelectedPortfolioFaultCountry(countries);
      setSelectedPortfolioFaultCity(cities);
      setSelectedPortfolioFaultProject(projects);
    }
  }

  handleSelectDisplayMode = (event) => {
    const displayMode = event.target.value;
    const { 
      setSelectedPortfolioFaultDisplayMode, 
    } = this.props;
  
    setSelectedPortfolioFaultDisplayMode(displayMode);

  };
  
  // method to determine visible checkboxes based on the selected portfolio level
  getVisibleCheckboxes = () => {
    const {
      selectedPortfolioFaultLevel,
      selectAllFaultCountries,
      selectAllFaultCities,
      selectAllFaultProjects,
      selectedFaultCountries,
      selectedFaultCities,
      selectedFaultProjects
    } = this.state;
  
    const hasSelectedCountry = selectedFaultCountries.length > 0;
    const hasSelectedCity = selectedFaultCities.length > 0;
    const hasSelectedProject = selectedFaultProjects.length > 0;
  
    return {
      showCountry: selectedPortfolioFaultLevel === 'country' || selectedPortfolioFaultLevel === 'city' || selectedPortfolioFaultLevel === 'project',
  
      showCity: (selectedPortfolioFaultLevel === 'city' || selectedPortfolioFaultLevel === 'project') &&
                (selectAllFaultCountries || hasSelectedCountry),
  
      showProject: selectedPortfolioFaultLevel === 'project' &&
                   (selectAllFaultCountries || hasSelectedCountry) &&
                   (selectAllFaultCities || hasSelectedCity),
  
      showStation:
        (selectedPortfolioFaultLevel === 'country' && hasSelectedCountry) ||
        (selectedPortfolioFaultLevel === 'city' && hasSelectedCountry && hasSelectedCity) ||
        (selectedPortfolioFaultLevel === 'project' &&
          hasSelectedCountry &&
          hasSelectedCity &&
          hasSelectedProject)
    };
  };
  
  handleSelectYear = (event) => {
    const { setSelectedPortfolioFaultYear, setSelectedPortfolioFaultMonth, setSelectedPortfolioFaultDay } = this.props;
    const selectedYear = parseInt(event.target.value, 0);
  
    setSelectedPortfolioFaultYear(selectedYear);
    setSelectedPortfolioFaultMonth(""); // Reset month and day
    setSelectedPortfolioFaultDay("");
  };
  
  handleSelectMonth = (event) => {
    const { setSelectedPortfolioFaultMonth, setSelectedPortfolioFaultDay } = this.props;
    const selectedMonth = event.target.value;
  
    setSelectedPortfolioFaultMonth(selectedMonth);
    setSelectedPortfolioFaultDay(""); // Reset day when month changes
  };
  
  handleSelectDay = (event) => {
    const { setSelectedPortfolioFaultDay } = this.props;
    const selectedDay = String(event.target.value).padStart(2, '0'); // convert to string first
  
    setSelectedPortfolioFaultDay(selectedDay);
  };
  
  handleCountryChange = async (event) => {
    const { value, checked } = event.target;
    const { selectedFaultCountries } = this.state;
    const { 
      portfolioFaultDetails,
      setSelectedPortfolioFaultCountry,
      setSelectedPortfolioFaultCity,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations
    } = this.props;

    try {
      // 1. Update country selection
      const updatedCountries = checked
        ? [...selectedFaultCountries, value]
        : selectedFaultCountries.filter(country => country !== value);

      // 2. Get valid cities for selected countries
      const validCities = portfolioFaultDetails.stationDetails
        .filter(station => updatedCountries.includes(station.country))
        .map(station => station.city)
        .filter((city, index, self) => self.indexOf(city) === index);

      // 3. Get valid projects for selected countries and cities
      const validProjects = portfolioFaultDetails.stationDetails
        .filter(station => 
          updatedCountries.includes(station.country) &&
          validCities.includes(station.city)
        )
        .map(station => station.project)
        .filter((project, index, self) => self.indexOf(project) === index);

      // 4. Get valid stations
      const validStations = portfolioFaultDetails.stationDetails
        .filter(station => 
          updatedCountries.includes(station.country) &&
          validCities.includes(station.city) &&
          validProjects.includes(station.project)
        )
        .map(station => station.name);

      // 5. Update local state
      this.setState({
        selectedFaultCountries: updatedCountries,
        selectAllFaultCountries: updatedCountries.length === portfolioFaultDetails.countryList.length,
        selectedFaultCities: validCities,
        selectAllFaultCities: validCities.length === portfolioFaultDetails.cityList.length,
        selectedFaultProjects: validProjects,
        selectAllFaultProjects: validProjects.length === portfolioFaultDetails.projectList.length,
        selectedFaultStations: validStations,
        selectAllFaultStations: validStations.length === portfolioFaultDetails.stationDetails.length
      });

      // 6. Update Redux state
      setSelectedPortfolioFaultCountry(updatedCountries);
      setSelectedPortfolioFaultCity(validCities);
      setSelectedPortfolioFaultProject(validProjects);
      setSelectedPortfolioFaultStations(validStations);

      // 7. Update fault data if we have stations
      if (validStations.length > 0) {
        await this.updateFaultData(validStations);
      }

    } catch (error) {
      console.error('Error updating country filters:', error);
    }
  };
  
  handleSelectAllCountries = async () => {
    const { selectAllFaultCountries } = this.state;
    const { 
      portfolioFaultDetails,
      setSelectedPortfolioFaultCountry,
      setSelectedPortfolioFaultCity,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations,
      resetPortfolioFaultData,
      resetPortfolioFaultLog,
    } = this.props;

    const countries = portfolioFaultDetails.countryList || [];
    const cities = portfolioFaultDetails.cityList || [];
    const projects = portfolioFaultDetails.projectList || [];
    const stations = (portfolioFaultDetails.stationDetails || []).map(station => station.name);

    if (selectAllFaultCountries) {
      // When unchecking "All" for countries
      this.setState({ 
        selectedFaultCountries: [], 
        selectAllFaultCountries: false,
        selectedFaultCities: [],
        selectAllFaultCities: false,
        selectedFaultProjects: [],
        selectAllFaultProjects: false,
        selectedFaultStations: [],
        selectAllFaultStations: false
      });

      // Clear states in Redux
      setSelectedPortfolioFaultCountry([]);
      setSelectedPortfolioFaultCity([]);
      setSelectedPortfolioFaultProject([]);
      setSelectedPortfolioFaultStations([]);
      resetPortfolioFaultData();
      resetPortfolioFaultLog();

    } else {
      // When checking "All" for countries
      this.setState({ 
        selectedFaultCountries: countries, 
        selectAllFaultCountries: true,
        selectedFaultCities: cities,
        selectAllFaultCities: true,
        selectedFaultProjects: projects,
        selectAllFaultProjects: true,
        selectedFaultStations: stations,
        selectAllFaultStations: true
      });

      // Update Redux states
      setSelectedPortfolioFaultCountry(countries);
      setSelectedPortfolioFaultCity(cities);
      setSelectedPortfolioFaultProject(projects);
      setSelectedPortfolioFaultStations(stations);

      // Update fault data if we have stations
      if (stations.length > 0) {
        await this.updateFaultData(stations);
      }
    }
  };
  
  handleCityChange = async (event) => {
    const { value, checked } = event.target;
    const { selectedFaultCities, selectedFaultCountries } = this.state;
    const { 
      portfolioFaultDetails,
      setSelectedPortfolioFaultCity,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations
    } = this.props;

    try {
      // 1. Update city selection
      const updatedCities = checked
        ? [...selectedFaultCities, value]
        : selectedFaultCities.filter(city => city !== value);

      // 2. Get valid projects for selected cities
      const validProjects = portfolioFaultDetails.stationDetails
        .filter(station => 
          selectedFaultCountries.includes(station.country) &&
          updatedCities.includes(station.city)
        )
        .map(station => station.project)
        .filter((project, index, self) => self.indexOf(project) === index);

      // 3. Get valid stations
      const validStations = portfolioFaultDetails.stationDetails
        .filter(station => 
          selectedFaultCountries.includes(station.country) &&
          updatedCities.includes(station.city) &&
          validProjects.includes(station.project)
        )
        .map(station => station.name);

      // 4. Update local state
      this.setState({
        selectedFaultCities: updatedCities,
        selectAllFaultCities: updatedCities.length === portfolioFaultDetails.cityList.length,
        selectedFaultProjects: validProjects,
        selectAllFaultProjects: validProjects.length === portfolioFaultDetails.projectList.length,
        selectedFaultStations: validStations,
        selectAllFaultStations: validStations.length === portfolioFaultDetails.stationDetails.length
      });

      // 5. Update Redux state
      setSelectedPortfolioFaultCity(updatedCities);
      setSelectedPortfolioFaultProject(validProjects);
      setSelectedPortfolioFaultStations(validStations);

      // 6. Update fault data if we have stations
      if (validStations.length > 0) {
        await this.updateFaultData(validStations);
      }

    } catch (error) {
      console.error('Error updating city filters:', error);
    }
  };

  
  handleSelectAllCities = () => {
    const { selectAllFaultCities } = this.state;
    const { 
      portfolioFaultDetails, 
      setSelectedPortfolioFaultCity, 
      setSelectedPortfolioFaultProject, 
      setSelectedPortfolioFaultStations, 
      resetPortfolioFaultData, 
      resetPortfolioFaultLog 
    } = this.props;
  
    const cities = portfolioFaultDetails.cityList || [];
    const projects = portfolioFaultDetails.projectList || [];
    const stations = (portfolioFaultDetails.stationDetails || []).map(station => station.name);
  
    if (selectAllFaultCities) {
      this.setState({ 
        selectedFaultCities: [], 
        selectAllFaultCities: false,
        selectedFaultProjects: [], 
        selectAllFaultProjects: false,
        selectedFaultStations: [], 
        selectAllFaultStations: false,
        stationDetails: [], // Clear station details when unselecting all countries
      });
  
      setSelectedPortfolioFaultCity([]);
      setSelectedPortfolioFaultProject([]);
      setSelectedPortfolioFaultStations([]);
      resetPortfolioFaultData();
      resetPortfolioFaultLog();
    } else {
      this.setState({ 
        selectedFaultCities: cities, 
        selectAllFaultCities: true,
        selectedFaultProjects: projects, 
        selectAllFaultProjects: true,
        selectedFaultStations: stations, 
        selectAllFaultStations: true
      });
  
      setSelectedPortfolioFaultCity(cities);
      setSelectedPortfolioFaultProject(projects);
      setSelectedPortfolioFaultStations(stations);
    }
  };  

  handleProjectChange = async (event) => {
    const { value, checked } = event.target;
    const { selectedFaultProjects } = this.state;
    const { 
      portfolioFaultDetails,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations,
      selectedPortfolioFaultCountry,
      selectedPortfolioFaultCity
    } = this.props;

    try {
      // 1. Update project selection
      const updatedProjects = checked
        ? [...selectedFaultProjects, value]
        : selectedFaultProjects.filter(project => project !== value);

      // 2. Get valid stations based on selected filters
      const validStations = portfolioFaultDetails.stationDetails
        .filter(station => 
          selectedPortfolioFaultCountry.includes(station.country) &&
          selectedPortfolioFaultCity.includes(station.city) &&
          updatedProjects.includes(station.project)
        )
        .map(station => station.name);

      // 3. Update local state - auto-select all valid stations
      this.setState({
        selectedFaultProjects: updatedProjects,
        selectAllFaultProjects: updatedProjects.length === portfolioFaultDetails.projectList.length,
        selectedFaultStations: validStations,
        selectAllFaultStations: validStations.length === portfolioFaultDetails.stationDetails.length
      });

      // 4. Update Redux state
      setSelectedPortfolioFaultProject(updatedProjects);
      setSelectedPortfolioFaultStations(validStations);

      // 5. Update fault data if we have stations
      if (validStations.length > 0) {
        await this.updateFaultData(validStations);
      }

    } catch (error) {
      console.error('Error updating project filters:', error);
    }
  };
  
  handleSelectAllProjects = async () => {
    const { selectAllFaultProjects } = this.state;
    const { 
      portfolioFaultDetails,
      callPortfolioFaultDetails,
      setSelectedPortfolioFaultProject,
      setSelectedPortfolioFaultStations,
      resetPortfolioFaultData,
      resetPortfolioFaultLog,
      selectedPortfolioFaultCompany,
      selectedPortfolioFaultCountry,
      selectedPortfolioFaultCity
    } = this.props;

    const projects = portfolioFaultDetails.projectList || [];
    const stations = (portfolioFaultDetails.stationDetails || [])
      .filter(station => 
        selectedPortfolioFaultCountry.includes(station.country) &&
        selectedPortfolioFaultCity.includes(station.city)
      )
      .map(station => station.name);

    if (selectAllFaultProjects) {
      // When unchecking "All" for projects
      this.setState({ 
        selectedFaultProjects: [],
        selectAllFaultProjects: false,
        selectedFaultStations: [],
        selectAllFaultStations: false
      });

      // Clear states in Redux
      setSelectedPortfolioFaultProject([]);
      setSelectedPortfolioFaultStations([]);
      resetPortfolioFaultData();
      resetPortfolioFaultLog();

    } else {
      // When checking "All" for projects
      this.setState({ 
        selectedFaultProjects: projects,
        selectAllFaultProjects: true,
        selectedFaultStations: stations,
        selectAllFaultStations: true
      });

      // Update Redux states
      setSelectedPortfolioFaultProject(projects);
      setSelectedPortfolioFaultStations(stations);

      // Update fault data with new stations
      if (stations.length > 0) {
        await this.updateFaultData(stations);
      }
    }

    // Update portfolioFaultDetails
    const userId = getUserId();
    await callPortfolioFaultDetails({
      userId,
      company: [selectedPortfolioFaultCompany],
      country: selectedPortfolioFaultCountry,
      city: selectedPortfolioFaultCity,
      project: selectAllFaultProjects ? [] : projects
    });
  };
  
  handleStationChange = (event) => {
    const { value, checked } = event.target;
    const { selectedFaultStations } = this.state;
    const allStations = (this.props.portfolioFaultDetails.stationDetails || []).map(s => s.name);
  
    const updatedStations = checked
      ? [...selectedFaultStations, value]
      : selectedFaultStations.filter((station) => station !== value);
  
    const isAllSelected = updatedStations.length === allStations.length;
  
    this.setState({
      selectedFaultStations: updatedStations,
      selectAllFaultStations: isAllSelected,
    }, () => {
      this.forceUpdate(); // optional but for visual update consistency
    });
  
    this.props.setSelectedPortfolioFaultStations(updatedStations);

    if (updatedStations.length === 0) {
      this.props.resetPortfolioFaultData();
      this.props.resetPortfolioFaultLog();
    }
  };
  
  handleSelectAllStations = () => {
    const {
      selectAllFaultStations
    } = this.state;

    const {
      selectedPortfolioFaultCountry,
      selectedPortfolioFaultCity,
      selectedPortfolioFaultProject,
      portfolioFaultDetails,
      setSelectedPortfolioFaultStations,
      resetPortfolioFaultData,
      resetPortfolioFaultLog
    } = this.props;

    const { stationDetails = [] } = portfolioFaultDetails;

    const shouldFilter =
      selectedPortfolioFaultCountry?.length &&
      selectedPortfolioFaultCity?.length &&
      selectedPortfolioFaultProject?.length;

    const allStations = stationDetails
      .filter(station =>
        !shouldFilter ||
        (
          selectedPortfolioFaultCountry.includes(station.country) &&
          selectedPortfolioFaultCity.includes(station.city) &&
          selectedPortfolioFaultProject.includes(station.project)
        )
      )
      .map(station => station.name);

    if (selectAllFaultStations) {
      this.setState({
        selectedFaultStations: [],
        selectAllFaultStations: false
      });
      setSelectedPortfolioFaultStations([]);
      resetPortfolioFaultData();
      resetPortfolioFaultLog();
    } else {
      this.setState({
        selectedFaultStations: allStations,
        selectAllFaultStations: true
      });
      setSelectedPortfolioFaultStations(allStations);
    }
  };

  updateFaultData = async (validStations) => {
    const {
      resetPortfolioFaultData,
      resetPortfolioFaultLog,
      setSelectedPortfolioFaultStations,
    } = this.props;
  
    try {
      if (!validStations || validStations.length === 0) {
        resetPortfolioFaultData();
        resetPortfolioFaultLog();
        return;
      }
  
      setSelectedPortfolioFaultStations(validStations);
  
    } catch (error) {
      console.error('Error updating fault data:', error);
    }
  };

  getFilteredCities = () => {
    const { portfolioFaultDetails } = this.props;
    const { selectedFaultCountries } = this.state;

    return portfolioFaultDetails.cityList.filter(city => {
      // Check if this city belongs to any selected country
      return portfolioFaultDetails.stationDetails.some(station => 
        selectedFaultCountries.includes(station.country) && 
        station.city === city
      );
    });
  };

  getFilteredProjects = () => {
    const { portfolioFaultDetails } = this.props;
    const { selectedFaultCountries, selectedFaultCities } = this.state;

    return portfolioFaultDetails.projectList.filter(project => {
      // Check if this project belongs to any selected country and city
      return portfolioFaultDetails.stationDetails.some(station => 
        selectedFaultCountries.includes(station.country) && 
        selectedFaultCities.includes(station.city) && 
        station.project === project
      );
    });
  };

  getFilteredStations = () => {
    const { portfolioFaultDetails } = this.props;
    const { selectedFaultCountries, selectedFaultCities, selectedFaultProjects } = this.state;

    return portfolioFaultDetails.stationDetails.filter(station => 
      selectedFaultCountries.includes(station.country) &&
      selectedFaultCities.includes(station.city) &&
      selectedFaultProjects.includes(station.project)
    );
  };

  render() {
    const { selectedPortfolioFaultLevel } = this.state;
    const {
      classes,
      portfolioFaultLevels,
      portfolioFaultDetails,
      selectedPortfolioFaultCompany,
      selectedPortfolioFaultDisplayMode,
      selectedPortfolioFaultYear,
      selectedPortfolioFaultMonth,
      selectedPortfolioFaultDay
      // selectedPortfolioStations,
    } = this.props;

    const companies = portfolioFaultDetails.companyList || [];
    const countries = portfolioFaultDetails.countryList || [];
    const cities = portfolioFaultDetails.cityList || [];
    const projects = portfolioFaultDetails.projectList || [];
    const stations = portfolioFaultDetails.stationDetails || [];

    const isAdmin = portfolioFaultDetails.userRole === 'admin';

    const { showCountry, showCity, showProject, showStation } = this.getVisibleCheckboxes();

    return (
      <div className={classes.form}>
        <Grid container alignItems="center">
          {/* Company Dropdown */}
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
              <InputLabel htmlFor="company-fault-select">Company</InputLabel>
              <Select
                value={selectedPortfolioFaultCompany}
                onChange={this.handleCompanyChange}
                displayEmpty
                input={
                  <OutlinedInput
                    labelWidth={75}
                    name="Company"
                    id="company-fault-select"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
                disabled={!isAdmin}
              >
                {isAdmin
                  ? companies.map((company, index) => (
                      <MenuItem key={index} value={company}>
                        {company}
                      </MenuItem>
                    ))
                  : <MenuItem value={selectedPortfolioFaultCompany}>{selectedPortfolioFaultCompany}</MenuItem>}
              </Select>
            </FormControl>
          </Grid>
          {/* Portfolio Level Dropdown */}
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
              <InputLabel htmlFor="portfolio-fault-level-select">Portfolio Selection</InputLabel>
              <Select
                value={selectedPortfolioFaultLevel.toLowerCase()} // Ensure it's always lowercase
                onChange={this.handlePortfolioFaultLevelChange}
                input={
                  <OutlinedInput
                    labelWidth={135}
                    name="Portfolio Level"
                    id="portfolio-fault-level-select"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                {portfolioFaultLevels.map((level) => (
                  <MenuItem key={level.portfolioLevelId} value={level.portfolioSelection.toLowerCase()}>
                    {level.portfolioSelection}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Display Mode Dropdown */}
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
              <InputLabel htmlFor="select-display-mode">
                {strings.lblDisplayMode}
              </InputLabel>
              <Select
                value={selectedPortfolioFaultDisplayMode}
                onChange={this.handleSelectDisplayMode}
                input={
                  <OutlinedInput
                    labelWidth={100}
                    name={strings.lblRange}
                    id="select-display-mode"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                <MenuItem value="year">{strings.lblYear}</MenuItem>
                <MenuItem value="month">{strings.lblMonth}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} className={classes.scrollContainer}>
            {/* Year Dropdown (Appears in Year, Month, Day, and Range Modes) */}
            {["year", "month"].includes(selectedPortfolioFaultDisplayMode) && (
              <Grid item xs={12}>
                <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
                  <InputLabel htmlFor="select-year">Year</InputLabel>
                  <Select
                    value={selectedPortfolioFaultYear}
                    onChange={this.handleSelectYear}  // Updated to use correct handler
                    input={<OutlinedInput labelWidth={35} 
                    id="select-year" 
                    className={classes.formControlWrapperSelectMenu}
                    />}
                  >
                    {portfolioFaultDetails.yearList.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            {/* Month Dropdown */}
            {["month", "day", "range"].includes(selectedPortfolioFaultDisplayMode) && selectedPortfolioFaultYear && (
              <Grid item xs={12}>
                <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
                  <InputLabel htmlFor="select-month">Month</InputLabel>
                  <Select
                    value={selectedPortfolioFaultMonth}
                    onChange={this.handleSelectMonth}  
                    input={<OutlinedInput labelWidth={50} 
                    id="select-month" 
                    className={classes.formControlWrapperSelectMenu}
                    />}
                  >
                    {this.getAvailableMonths(selectedPortfolioFaultYear).map(({ value, name, disabled }) => (
                      <MenuItem key={value} value={value} disabled={disabled}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            {/* Day Dropdown (Appears in Day and Range Modes) */}
            {["day", "range"].includes(selectedPortfolioFaultDisplayMode) && selectedPortfolioFaultMonth && selectedPortfolioFaultYear && (
              <Grid item xs={12}>
                <FormControl className={classes.formControlWrapper} variant="outlined" fullWidth>
                  <InputLabel htmlFor="select-day">Day</InputLabel>
                  <Select
                    value={selectedPortfolioFaultDay}
                    onChange={this.handleSelectDay}  // Updated to use correct handler
                    input={<OutlinedInput labelWidth={30} id="select-day" />}
                  >
                  {this.getDaysInMonth(selectedPortfolioFaultYear, selectedPortfolioFaultMonth).map((day) => {
                    const paddedDay = String(day).padStart(2, '0');
                    return (
                      <MenuItem key={paddedDay} value={paddedDay}>
                        {paddedDay}
                      </MenuItem>
                    );
                  })}
                  </Select>
                </FormControl>
              </Grid>
            )}
            {/* Country Checkbox Group */}
            {showCountry && (
              <Grid item xs={12}>
                <FormControl component="fieldset" className={classes.formControlWrapperCheckbox}>
                  <FormLabel component="legend" className={classes.CheckboxFormLabelCountry}>Country</FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.selectAllFaultCountries}
                          onChange={this.handleSelectAllCountries}
                          color="primary"
                        />
                      }
                      label={`All`}
                    />
                    {countries.map((country, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            value={country}
                            checked={this.state.selectedFaultCountries.includes(country)} // Correct state here
                            onChange={this.handleCountryChange}
                            color="primary"
                          />
                        }
                        label={country}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
            {/* City Checkbox Group */}
            {showCity && cities.length > 0 && (
              <Grid item xs={12}>
                <FormControl component="fieldset" className={classes.formControlWrapperCheckbox}>
                  <FormLabel component="legend" className={classes.CheckboxFormLabelCity}>City</FormLabel>
                  <FormGroup>
                    {/* Select All Cities Checkbox */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.selectAllFaultCities}
                          onChange={this.handleSelectAllCities}
                          color="primary"
                        />
                      }
                      label={`All`}
                    />
                    {/* Individual City Checkboxes */}
                    {cities.map((city, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            value={city}
                            checked={(this.state.selectedFaultCities || []).includes(city)} // Ensure it's always an array
                            onChange={this.handleCityChange}
                            color="primary"
                          />
                        }
                        label={city}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
            {/* Project Checkbox Group */}
            {showProject && projects.length > 0 && (
              <Grid item xs={12}>
                <FormControl component="fieldset" className={classes.formControlWrapperCheckbox}>
                  <FormLabel component="legend" className={classes.CheckboxFormLabelProject}>Project</FormLabel>
                  <FormGroup>
                    {/* Select All Projects Checkbox */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.selectAllFaultProjects} // Boolean value
                          onChange={this.handleSelectAllProjects}
                          color="primary"
                        />
                      }
                      label={`All`}
                    />
                    {/* Individual Project Checkboxes */}
                    {projects.map((project, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            value={project}
                            checked={(this.state.selectedFaultProjects || []).includes(project)}
                            onChange={this.handleProjectChange}
                            color="primary"
                          />
                        }
                        label={project}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
            {/* Station Checkbox Group */}
            {showStation && stations.length && (
              <Grid item xs={12}>
                <FormControl component="fieldset" className={classes.formControlWrapperCheckbox}>
                  <FormLabel component="legend" className={classes.CheckboxFormLabelProject}>Stations</FormLabel>
                  <div className={classes.stationScrollWrapper}> {/* NEW WRAPPER FOR SCROLL */}
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.selectAllFaultStations}
                            onChange={this.handleSelectAllStations}
                            color="primary"
                          />
                        }
                        label={`All`}
                        />
                      {stations.filter( station => 
                        (this.props.selectedPortfolioFaultCountry.length === 0 || this.props.selectedPortfolioFaultCountry.includes(station.country)) &&
                        (this.props.selectedPortfolioFaultCity.length === 0 || this.props.selectedPortfolioFaultCity.includes(station.city)) &&
                        (this.props.selectedPortfolioFaultProject.length === 0 || this.props.selectedPortfolioFaultProject.includes(station.project))
                      ).map((station, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              value={station.name}
                              checked={(this.state.selectedFaultStations || []).includes(station.name)}
                              onChange={this.handleStationChange}
                              color="primary"
                            />
                          }
                          label={`${station.name} (${station.description})`}
                        />
                      ))}
                    </FormGroup>
                  </div>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  portfolioFaultTotalize: portfolioFaultReducer.getPortfolioFaultTotalize(state),
  portfolioFaultDetails: portfolioFaultReducer.getPortfolioFaultDetails(state),
  portfolioFaultLevels: portfolioFaultReducer.getPortfolioFaultLevels(state),
  portfolioFaultData: portfolioFaultReducer.getPortfolioFaultData(state),
  portfolioFaultLogData: portfolioFaultReducer.getPortfolioFaultLogData(state),

  selectedPortfolioFaultCompany: portfolioFaultReducer.getSelectedPortfolioFaultCompany(state),
  selectedPortfolioFaultCountry: portfolioFaultReducer.getSelectedPortfolioFaultCountry(state),
  selectedPortfolioFaultCity: portfolioFaultReducer.getSelectedPortfolioFaultCity(state),
  selectedPortfolioFaultProject: portfolioFaultReducer.getSelectedPortfolioFaultProject(state),
  selectedPortfolioFaultStations: portfolioFaultReducer.getSelectedPortfolioFaultStations(state), // Fixed prop name

  selectedPortfolioFaultDisplayMode: portfolioFaultReducer.getSelectedPortfolioFaultDisplayMode(state),
  selectedPortfolioFaultLevel: portfolioFaultReducer.getSelectedPortfolioFaultLevel(state),

  selectedPortfolioFaultYear: portfolioFaultReducer.getSelectedPortfolioFaultYear(state),
  selectedPortfolioFaultMonth: portfolioFaultReducer.getSelectedPortfolioFaultMonth(state),
  selectedPortfolioFaultDay: portfolioFaultReducer.getSelectedPortfolioFaultDay(state)
})

const mapActionsToProps = {
  callPortfolioFaultTotalize: portfolioFaultActionMgr.callPortfolioFaultTotalize,
  callPortfolioFaultDetails: portfolioFaultActionMgr.callPortfolioFaultDetails,
  callPortfolioFaultLevels: portfolioFaultActionMgr.callPortfolioFaultLevels,
  callPortfolioFault: portfolioFaultActionMgr.callPortfolioFaultData,
  callPortfolioFaultLog: portfolioFaultActionMgr.callPortfolioFaultLogData,

  setSelectedPortfolioFaultCompany: portfolioFaultActionMgr.setSelectedPortfolioFaultCompany,
  setSelectedPortfolioFaultCountry: portfolioFaultActionMgr.setSelectedPortfolioFaultCountry,
  setSelectedPortfolioFaultCity: portfolioFaultActionMgr.setSelectedPortfolioFaultCity,
  setSelectedPortfolioFaultProject: portfolioFaultActionMgr.setSelectedPortfolioFaultProject,
  setSelectedPortfolioFaultStations: portfolioFaultActionMgr.setSelectedPortfolioFaultStations,

  setSelectedPortfolioFaultLevel: portfolioFaultActionMgr.setSelectedPortfolioFaultLevel,
  setSelectedPortfolioFaultDisplayMode: portfolioFaultActionMgr.setSelectedPortfolioFaultDisplayMode,

  setSelectedPortfolioFaultYear: portfolioFaultActionMgr.setSelectedPortfolioFaultYear,
  setSelectedPortfolioFaultMonth: portfolioFaultActionMgr.setSelectedPortfolioFaultMonth,
  setSelectedPortfolioFaultDay: portfolioFaultActionMgr.setSelectedPortfolioFaultDay,
  resetPortfolioFaultData: portfolioFaultActionMgr.resetPortfolioFaultData,
  resetPortfolioFaultLog: portfolioFaultActionMgr.resetPortfolioFaultLog,

}

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(PortfolioFaultForm)
);
